import { BrowserRouter, Route, Routes } from 'react-router-dom';
import PrivateRoutes from './PrivateRoutes';
import LandingPage from './components/Landing';
import ConfirmationPage from './pages/auth/ConfirmationPage';
import InvitePage from './pages/auth/InvitePage';
import Login from './pages/auth/login';
import SignUp from './pages/auth/register';
import Account from './pages/dashboard/account';
import DashboardPage from './pages/dashboard/home';
import Notifications from './pages/dashboard/notifications';
import ProjectTeam from './pages/dashboard/projectteam';
import Users from './pages/dashboard/users';
import ForgotPasswordPage from './pages/forgot-password';
import JiraCallback from './pages/jira-callback';
import LogsPage from './pages/logs-management';
import UserProjectsPage from './pages/profile/user-projects';
import ConfigurationPage from './pages/project/configurations';
import ProjectDashboardPage from './pages/project/project-dashboard';
import ResetPasswordPage from './pages/reset-password';
import SingleTestExecutionPage from './pages/test-management/test-execution';
// import TestPlayerPage from './pages/test-management/test-player';
import AccessDenied from './pages/AccessDenied';
import NoRoute from './pages/NoRouteFound';
import AdminDashboardPage from './pages/admin/admin-dashboard';
import AdminReleaseNotesPage from './pages/admin/release-notes';
import DefectIntelligencePage from './pages/dashboard/defect-intelligence';
import DocumentationPage from './pages/dashboard/documentation';
import ReportsPage from './pages/dashboard/reports';
import PlatformUpdatesPage from './pages/dashboard/updates';
import { Privacy } from './pages/privacy';
import TestIntelligencePage from './pages/test-management/testIntelligence';
import TestCasesDetailsPage from './pages/test-management/testcase-details';
import TestCasesPage from './pages/test-management/testcases';
import TestCycleDetailsPage from './pages/test-management/testcycle-details';
import TestCyclesPage from './pages/test-management/testcycles';
import TestSuitesPage from './pages/test-management/testsuites';
import UnauthorizedPage from './pages/unauthorized';
import HistoryPage from './components/project-dashboard/ProjectHistory';
import SlackCallbackComponent from './components/MyProfile/notifications/SlackCallbackComponent';
import ProjectIssuesPage from './pages/project/project-issues';
import CustomerDetailPage from './components/admin-dashboard/customer/CustomerDetailPage';
export function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<LandingPage />} />
        <Route path="/register" element={<SignUp />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path='/reset-password' element={<ResetPasswordPage />} />
        <Route path='/change-password' element={<ResetPasswordPage />} />
        <Route path="/confirm" element={<ConfirmationPage />} />
        <Route path="/invite-accept" element={<InvitePage />} />
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
        <Route path="/logs" element={<LogsPage />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route element={<PrivateRoutes />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/settings" element={<Account />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/users" element={<Users />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/documentation" element={<DocumentationPage />} />
          {/* <Route path="/integrations" element={<IntegrationPage />} /> */}
          <Route path="/oauth/jira/callback" element={<JiraCallback />} />
          <Route path="/project/:projectId/configurations" element={<ConfigurationPage />} />
          <Route path="/project/:projectId/testcases" element={<TestCasesPage />} />
          <Route path="/project/:projectId/testcases/:testCaseKey" element={<TestCasesDetailsPage />} />
          <Route path="/project/:projectId/testcycles" element={<TestCyclesPage />} />
          <Route path="/project/:projectId/testcycles/:testCycleKey" element={<TestCycleDetailsPage />} />
          <Route path="/project/:projectId/testsuites" element={<TestSuitesPage />} />
          <Route path="project/:projectId/project-team" element={<ProjectTeam />} />
          <Route path="/project/:projectId/history" element={<HistoryPage entityType="project" />} />
          <Route path="/project/:projectId/testsuite/:suiteId/history" element={<HistoryPage entityType="testsuite" />} />
          <Route path="/project/:projectId/issues" element={<ProjectIssuesPage />} />
          <Route path="/projects" element={<UserProjectsPage />} />
          <Route path="/project/:projectId/dashboard" element={<ProjectDashboardPage />} />
          {/* <Route path="project/:projectId/testplayer/:testCycleId" element={<TestPlayerPage />} /> */}
          <Route path="project/:projectId/testexecution/:key" element={<SingleTestExecutionPage />} />
          <Route path="/project/:projectId/testplans" element={<TestIntelligencePage />} />
          <Route path="*" element={<NoRoute />} />
          <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
          <Route path="/admin/customers" element={<AdminDashboardPage />} />
          <Route path="/admin/customers/:organizationId" element={<CustomerDetailPage />} />
          <Route path="/access-denied" element={<AccessDenied />} />
          <Route path="/admin/release-notes" element={<AdminReleaseNotesPage />} />
          <Route path="/updates" element={<PlatformUpdatesPage />} />
          <Route path="/error" element={<NoRoute />} />
          <Route path="/slack/oauth/callback" element={<SlackCallbackComponent />} />
          <Route path="/defect-intelligence" element={<DefectIntelligencePage />} />
        </Route>
      </Routes>
    </BrowserRouter >
  );
}

export default Router;